$(document).ready(function () {

	$('.hero').not('.slick-initialized').slick(
	  {
		  arrows: false,
		  dots: false,
		  infinite: true,
		  autoplay: true,
		  cssEase: 'linear',
		  speed: 900,
		  autoplaySpeed: 4000,
		  pauseOnHover: false,
		  pauseOnFocus: false,
		  adaptiveHeight: false,
	  });

		$('.case-study-gallery-main').slick({
		 slidesToShow: 1,
		 slidesToScroll: 1,
		 arrows: true,
		 fade: true,
		 autoplay: true,
		 asNavFor: '.case-study-gallery-nav'
		});

	  $('.case-study-gallery-nav').slick({
		 slidesToShow: 4,
		 slidesToScroll: 1,
		 autoplay: true,
		 asNavFor: '.case-study-gallery-main',
		 dots: false,
		 arrows: false,
		 centerMode: false,
		 focusOnSelect: true
		});

		$('.carousel-main').slick({
		 slidesToShow: 1,
		 slidesToScroll: 1,
		 arrows: true,
		 fade: true,
		 autoplay: true,
		 asNavFor: '.carousel-nav'
		});

		$('.carousel-nav').slick({
		 slidesToShow: 4,
		 slidesToScroll: 1,
		 autoplay: true,
		 asNavFor: '.carousel-main',
		 dots: false,
		 arrows: false,
		 centerMode: false,
		 focusOnSelect: true
		});

		$('.menu-btn').click(function(){
			$('.main-nav ul.nav').addClass('active');
		});

		$('.close-menu').click(function(){
			$('.main-nav ul.nav').removeClass('active');
		});

		$('.menu-item-has-children').click(function(){
			$(this).children('.dropdown-wrap').toggleClass('active');
		});

		if($('.gallery-wrap').length){
				$('.gallery-wrap').magnificPopup({
				delegate: 'a',
				type: 'image',
				gallery:{
					enabled:true
				}
			});
		}

});
